import slick from 'slick-carousel';

export default function carouselMobile(width, el) {
  if ($(window).width() < width) {
    $(el).slick({
      slidesToShow: 2,
      prevArrow: `<button class="slick-prev">
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="31px" height="53px">
											<path fill-rule="evenodd"  fill="rgb(224, 224, 224)" d="M31.010,52.990 L14.227,26.499 L31.010,0.006 L16.774,0.006 L-0.010,26.499 L16.774,52.990 L31.010,52.990 Z"/>
										</svg>
									</button>`,
      nextArrow: `<button class="slick-next">
										<svg width="31px" height="53px">
											<path fill-rule="evenodd"  fill="rgb(224, 224, 224)" d="M-0.010,0.010 L16.773,26.501 L-0.010,52.993 L14.226,52.993 L31.010,26.501 L14.226,0.010 L-0.010,0.010 Z"/>
										</svg>
									</button>`,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }
}